import { Flex } from '@mantine/core';
import { ContentPlaceholder } from '../../../../components/content-placeholder/content-placeholder';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { useSelectedInitiativeStatuses } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { useAutoSelectFilters } from '../../filters/initiative-overview/initiative-overview.hooks';
import { useInitiativesData } from '../../hooks/initiative-data';
import { InitiativeOverviewTable } from './table/table';

export const InitiativeOverview = () => {
  const initiatives = useProcessAnalysisStore((state) => state.initiatives);
  const selectedInitiativeStatuses = useSelectedInitiativeStatuses();
  const { isFetching } = useInitiativesData();

  useAutoSelectFilters();

  if (!isFetching && (!initiatives || initiatives.length === 0)) {
    return <ContentPlaceholder />;
  }

  if (selectedInitiativeStatuses.length === 0) {
    return <ContentPlaceholder noFiltersApplied />;
  }

  return (
    <Flex direction="column" h="100%" w="100%" pos="relative">
      <InitiativeOverviewTable initiatives={initiatives} />
    </Flex>
  );
};
